import React, { VFC } from 'react'
import { addClassName } from 'utils'

type Props = {
  className?: string
}

const Heading: VFC<Props> = (props) => {
  return (
    <h2
      className={`space-y-3 text-center sm:space-y-8 lg:space-y-9 leading-none ${addClassName(
        props.className
      )}`}
    >
      <span className="font-cormorant-garamond text-custom-4 text-[28px] block sm:text-[56px] lg:text-[50px] font-medium">
        DRESS TYPE CHECK
      </span>
      <span className="block font-light sm:text-2xl lg:text-base">
        ドレスタイプ診断
      </span>
    </h2>
  )
}

export default Heading
